import { render, staticRenderFns } from "./SSPasswordReminderViewSent.vue?vue&type=template&id=92a0732a&scoped=true&"
import script from "./SSPasswordReminderViewSent.vue?vue&type=script&lang=js&"
export * from "./SSPasswordReminderViewSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a0732a",
  null
  
)

export default component.exports